import * as React from "react"

import { cn } from "../../lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-xl border border-brand-border bg-brand-background px-3 py-2 text-sm",
        "text-foreground placeholder:text-muted-foreground",
        "focus:outline-none focus:ring-2 focus:ring-brand-light/20 focus:border-brand-border",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "dark:border-brand-border dark:bg-brand-background dark:text-foreground dark:placeholder:text-muted-foreground",
        "dark:focus:ring-brand-light/20 dark:focus:border-brand-border",
        "resize-none",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
